'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var groupItems = function groupItems(items, spotReportViews) {
  var cities = (0, _index.alphabetizeItems)(items.filter(function (item) {
    return item.type === 'geoname' && item.hasSpots;
  }));
  var spots = items.filter(function (item) {
    return item.type === 'spot';
  }).map(function (spot) {
    var spotReportView = spotReportViews.find(function (_ref) {
      var _id = _ref._id;
      return _id === spot.spot;
    });
    if (!spotReportView) {
      return spot;
    }
    var newSpot = (0, _extends3.default)({}, spot, {
      hasCamera: spotReportView.cameras.length > 0,
      conditions: spotReportView.conditions
    });
    return newSpot;
  });
  if (cities.length === 0) {
    return [{
      city: null,
      spots: (0, _index.alphabetizeItems)(spots)
    }];
  }

  return cities.map(function (city) {
    return {
      city: city,
      spots: (0, _index.alphabetizeItems)(spots.filter(function (spot) {
        return spot.liesIn.includes(city._id);
      }))
    };
  });
};

exports.default = groupItems;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/utils/groupItems.js
// module id = 344
// module chunks = 0